var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/shipping/pdp-marketplace-shipping-returns.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"s-cms\">\n    ";
output += runtime.suppressValue(env.getFilter("markdown").call(context, (lineno = 1, colno = 6, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["marketplace_shipping-returns-disclaimer"]))), env.opts.autoescape);
output += "\n\n    ";
if((lineno = 3, colno = 12, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.product.sellerInfo.returnPolicy"]))) {
output += "\n\n        <h3>\n\n            ";
output += runtime.suppressValue((lineno = 7, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["marketplace_seller-shipping-returns"])), env.opts.autoescape);
output += "\n\n        </h3>\n\n        <p>\n            ";
output += runtime.suppressValue(env.getFilter("markdown").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")),"sellerInfo")),"returnPolicy")), env.opts.autoescape);
output += "\n        </p>\n\n    ";
;
}
output += "\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/shipping/pdp-marketplace-shipping-returns.j2"] , dependencies)